export function canEditTranslations(user: any): boolean {
    return !!(user && user.details && user.details.canManageTranslations);
}
